import React from "react";

// 1. Props mein candidates receive kiya aur default empty array rakha
export default function RecentCandidates({ candidates = [] }) {
  
  // Safe Array Check: Ensure kar rahe hain ki data strictly ek Array hi ho
  const safeCandidates = Array.isArray(candidates) ? candidates : [];

  return (
    <div className="bg-white rounded-2xl shadow-sm p-6">
      <h2 className="text-xl font-bold mb-5">
        Recent Candidates
      </h2>

      {/* 2. Agar safe array mein data hai toh map karenge, warna fallback */}
      {safeCandidates.length > 0 ? (
        safeCandidates.map((candidate, index) => (
          <div
            key={candidate.id || index}
            className="flex justify-between py-3 border-b last:border-none"
          >
            <div>
              <h4 className="font-semibold">
                {candidate.name || (candidate.first_name ? `${candidate.first_name} ${candidate.last_name || ''}` : "Unknown Candidate")}
              </h4>

              <p className="text-gray-500 text-sm">
                {candidate.job || candidate.job_role || candidate.designation || "Candidate"}
              </p>
            </div>

            <span className="text-blue-600">
              New
            </span>
          </div>
        ))
      ) : (
        <p className="text-gray-500 text-sm text-center py-4">
          No recent candidates found.
        </p>
      )}
    </div>
  );
}